<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-select
        :items="items"
        return-object
        item-text="nazev"
        v-model="selectedItems"
        label="Dodavatelé"
        :hide-details="hideDetails"
        :outline="outline"
        class="mx-2"
        :rules="rules"
        :disabled="disabled"
        multiple
      >
        <template slot="selection" slot-scope="{ item, index }">
          <v-chip color="blue lighten-4">{{item.nazev}}</v-chip>
        </template>
      </v-select>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: function () {
    return {
      items: [],
      selectedItems: []
    }
  },
  props: {
    hideDetails: Boolean,
    outline: Boolean,
    rules: Array,
    value: Array,
    all: Boolean,
    disabled: Boolean
  },
  watch: {
    selectedItems (v) {
      this.$emit("changed", v);
      this.$emit("input", v.map((e) => { return e.id; }));
    }
  },
  mounted: function() {
    this.load();
  },
  methods: {
    load: function(v) {
      window.api.get("dodavatele/search").then(function(_body) {
        this.items = _body.data;
        var selectedItems = [];
        if (this.value != null) {
          var $f = this.items.filter((x) => this.value.indexOf(x.id) >= 0);
          if ($f.length > 0)
            this.selectedItems = $f;
          else
            this.selectedItems = [];
        }
        else {
          this.selectedItems = [];
        }
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/DodavateleSelect.vue